import React from 'react';
import { colors } from '@styleseat/brand';
import { Box, Inline } from '@styleseat/ui';
import {
  BodyText,
} from '../../../ui';
import {
  BasicStarIcon,
} from '../../../ui/Icons';

const TopServiceRatingBanner = ({ serviceRanking, serviceID }) => (
  <Inline
    minWidth={108}
    minHeight={20}
    color="#FFF2FA"
    borderRadius={24}
    space={4}
    justifyContent="center"
    alignItems="center"
    key={`${serviceID}_ranking_banner`}
    testID="top_service_card_rating_banner_776"
  >
    <Box
      testID="top_service_card_rating_banner_icon_776"
    >
      <BasicStarIcon
        width={12}
        height={12}
        color={colors.punch}
      />
    </Box>
    <BodyText
      appearance="smaller"
      testID="top_service_card_rating_banner_text_776"
    >
      #{serviceRanking} most popular
    </BodyText>
  </Inline>
);

export default TopServiceRatingBanner;
